import './style.css';
import Game from './core/Game.js';
import { setupConsoleFilters } from './utils/consoleManager.js';

// Setup console filters to only show essential game information
setupConsoleFilters();
 
import('@vercel/analytics')
    .then(({ inject }) => inject())
    .catch(() => {});

// Wait for DOM to be loaded
document.addEventListener('DOMContentLoaded', () => {
    const loadingStatus = document.getElementById('loading-status');
    
    try {
        // Update loading status
        if (loadingStatus) {
            loadingStatus.textContent = 'Initializing game...';
        }
        
        // Create the game but don't start it yet
        const game = new Game();
        
        // Prepare game objects in a paused state
        if (typeof game.prepare === 'function') {
            game.prepare();
        } else {
            // For backward compatibility if prepare method isn't implemented
            console.log('Game.prepare() method not available, using compatibility mode');
        }
        
        // Create a global reference so the welcome screen can access it
        window.gameInstance = game;
        
        // Listen for the welcome screen close event
        window.addEventListener('welcome_screen_closed', () => {
            console.log('Welcome screen closed, starting game');
            game.start();
        });
        
    } catch (error) {
        // This error is important enough to display regardless of console filters
        console.error('Failed to initialize game:', error);
        if (loadingStatus) {
            loadingStatus.innerHTML = `<div style="color: red">
                <strong>Error loading game:</strong><br>
                ${error.message}<br><br>
                <div style="font-size: 14px; color: #aaa">
                    Please check console for more details.
                </div>
                <pre style="font-size: 12px; text-align: left; margin-top: 10px; overflow: auto; max-height: 200px;">${error.stack}</pre>
            </div>`;
        }
    }
}); 
